import React from 'react';
import { bool,func } from 'prop-types';
import { StyledBurger } from './Burger.styled';

const Burger = ({ open,setOpen,...props }) => {

   const isExpanded = open ? true : false;

   const openClose = () => {
      var image = document.getElementById('hamburger');
      if (open) {

         // change image to hamburger
         image.src = "./img/final/menu_light.png";

         window.openMenu = false;
         setOpen(!open);
         document.getElementById("infinityrt-canvas").style.transition = 'all 0.3s ease-in-out';
         document.getElementById("infinityrt-canvas").style.marginLeft = '0px';

         // callouts shift left
         // document.getElementById("hotspot5").style.marginLeft = '0px';
         // document.getElementsByClassName("hotspot").style.marginLeft = '0px';

         var x = document.getElementsByClassName("hotspot");
         var i;
         for (i = 0; i < x.length; i++) {
            x[i].style.transition = 'margin 0.3s ease-in-out';
            x[i].style.marginLeft = "0px";
         }

         console.log('close');
         document.getElementsByClassName("select_appliances")[0].style.backgroundColor = "transparent";
      }
      else {

         document.getElementsByClassName("select_appliances")[0].style.backgroundColor = "#9e9e9e";

         // change image to cross
         image.src = "./img/final/cross_light.svg";

         window.openMenu = true;
         setOpen(!open);
         document.getElementById("infinityrt-canvas").style.transition = 'all 0.3s ease-in-out';
         

         // canvas shift
         // document.getElementById("infinityrt-canvas").style.marginLeft = '161px';

         // callouts shift left
         // document.getElementById("hotspot5").style.marginLeft = '322px';
         // document.getElementsByClassName("hotspot").style.marginLeft = '322px';

         var x = document.getElementsByClassName("hotspot");
         var i;
         for (i = 0; i < x.length; i++) {
            x[i].style.transition = 'margin 0.3s ease-in-out';
            // x[i].style.marginLeft = "161px";
         }

         console.log('open');
      }
   }

   return (
      // <div><img src="./img/icons/1_black.svg" alt="ICON1" style={{width: '35px', float: 'left', marginLeft: '12px'}}/></div>
      <StyledBurger id="mainMenuIcon" aria-label="Toggle menu" aria-expanded={isExpanded} open={open} onClick={openClose} {...props}>

         <img src="./img/final/cross_light.svg" id="hamburger" alt="ICON1" style={{ width: '53px',height: '45px',borderRadius: '0',position: 'relative',top: '45px',left: '-5px' }} />
      </StyledBurger>
   )
}

Burger.propTypes = {
   open: bool.isRequired,
   setOpen: func.isRequired,
};

export default Burger;
